import React from 'react';
import { ArticleSection } from './ArticleSection';
export function FoundersStory() {
  return <div className="bg-[#E8EDE9]/50 py-4 my-16 border-y border-sage/20" data-id="element-167">
      <ArticleSection eyebrow="How I found the answer" title="Why I Spent Three Years Treating My Gut — Before I Realised I Was Treating the Wrong Thing" data-id="element-168">
        <div className="mb-6" data-id="element-169">
          <span className="inline-block px-3 py-1 bg-sage/10 text-sage text-[11px] font-bold uppercase tracking-widest rounded-full" data-id="element-170">
            The Founder's Story
          </span>
        </div>

        <p data-id="element-171">For about three years, my life ran on a very short leash.</p>

        <p data-id="element-172">
          I had the bloating that appeared without fail every afternoon,
          regardless of what I ate. I had the cramping that could go from zero
          to unbearable in twenty minutes. I had the bathroom urgency that meant
          I was mentally mapping every venue I walked into before I'd even said
          hello to the people I was meeting. I had the food list — the growing,
          humiliating list of things I'd eliminated one by one because they
          seemed to trigger something, until I was eating like a monk and my gut
          was still misbehaving.
        </p>

        <p data-id="element-173">
          I went through the standard path. Two gastroenterologists. Three
          rounds of Rifaximin. A six-month stretch of omeprazole for the reflux
          that arrived halfway through. An elimination diet that lasted eight
          months and cost me more social invitations than I can count. A
          functional medicine practitioner who charged me £400 a session to run
          tests that confirmed I had SIBO — which I already knew — and then
          prescribed more Rifaximin.
        </p>

        <p data-id="element-174">
          The bacteria kept coming back. Every time. Sometimes within six weeks
          of finishing the antibiotics.
        </p>

        <p data-id="element-175">
          I was treating a symptom. Repeatedly. Expensively. And nobody was
          asking why the symptom kept returning.
        </p>

        <p data-id="element-176">
          The answer came from an unexpected place — a 2000 paper in Nature by a
          surgeon-scientist named Dr. Kevin Tracey. He had been researching
          sepsis and stumbled onto something much larger: that the vagus nerve —
          the long cable running from your brainstem to your colon — is the
          body's master regulator of inflammation, gut motility, and the
          gut-brain axis. And that when it goes quiet, a cascade of dysfunction
          follows that looks, from the outside, like a collection of separate
          gut disorders.
        </p>

        <p data-id="element-177">It looked exactly like what I had.</p>

        <p data-id="element-178">
          I started researching vagal stimulation. I found the clinical
          literature on non-invasive VNS — transcutaneous cervical stimulation,
          delivered through electrodes placed on the neck over the carotid
          triangle, where the vagus nerve runs close to the skin's surface. I
          found a 2024 trial in the American Journal of Gastroenterology showing
          statistically significant improvements in IBS severity, gut pain, and
          quality of life — all at p&lt;0.001 — in patients who received four
          weeks of daily vagal stimulation. Same mechanism. Same nerve. Same
          result I'd been chasing with antibiotics for three years.
        </p>

        <p data-id="element-179">That was the beginning of Nerva™.</p>

        <p data-id="element-180">
          I built it because I needed it. And because the people I know who are
          still on their third round of Rifaximin, still on the low-FODMAP
          treadmill, still being handed SSRI prescriptions for a gut problem —
          they need it too.
        </p>
      </ArticleSection>
    </div>;
}